<template>
  <div class="label" :class="{'flex':flex}">
    <span class="name">{{name}}</span>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "Label",
    props: ["name", "flex"]
  }
</script>

<style lang="scss" scoped>
  .flex {
    display: flex;
  }

  .label {

    list-style: none;
    float: left;
    margin-right: 100px;
    font-size: 14px;
    color: #8d8b8b;
    width: 100%;
    line-height: 30px;



    .value {
      padding-left: 10px;
      color: #000000;
      opacity: 0.85;
    }
  }
</style>
